import { ParamConfig } from "../../../utils/params/ParamsConfig";
import { CoreWalker } from "../../../../../core/Walker";
export function RootMainCameraParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.mainCameraPath = ParamConfig.STRING("", {
        cook: false,
        separatorBefore: true,
        objectMask: true
      });
    }
  };
}
export class RootMainCameraController {
  constructor(node) {
    this.node = node;
  }
  setCamera(object) {
    const path = this.node.scene().objectsController.objectPath(object);
    this.setCameraPath(path);
  }
  setCameraPath(path) {
    this.node.p.mainCameraPath.set(path);
  }
  rawCameraPath() {
    return this.node.p.mainCameraPath.rawInput();
  }
  async cameraPath() {
    const param = this.node.p.mainCameraPath;
    if (param.isDirty()) {
      await param.compute();
    }
    return param.value;
  }
  async camera() {
    const path = await this.cameraPath();
    const object = this.node.scene().objectsController.findObjectByMask(path);
    return object;
  }
  async cameraCreatorNode() {
    const path = await this.cameraPath();
    const elements = path.split(CoreWalker.SEPARATOR);
    const nodeName = elements[1];
    const objNode = this.node.node(nodeName);
    if (elements.length != 2) {
      const displayNodeController = objNode.displayNodeController;
      if (displayNodeController) {
        return objNode.displayNodeController.displayNode() || objNode;
      }
    }
    return objNode;
  }
}
